import { EClientKey } from "./clients";

export const PATH = {
  HOME: "/",
  SERVICE: "/service",
  PRICING: "/pricing",
  BLOG: "https://blog.searchright.net",
  BLOG_DETAIL: (slug: string) => `/blog/${slug}`,
  CLIENT_LOGIN: "https://hr.searchright.net/login",
  DEMO_CLIENT: "https://demo.searchright.net/?utm_source=landing",
  REQUEST: "/request",
  PRIVACY: "https://searchright.notion.site/privacy-policy",
  TERMS: "https://searchright.notion.site/terms-of-service",
  LINKEDIN: "https://www.linkedin.com/company/searchright-ai",
  COMPANY_INTRO: "https://drive.google.com/file/d/1bABFqxShhCQVeBcKKUJ37EkSE4UCA8Ay/view",
};

export const CLIENT_LOGO_IMAGE_PATH = ({ client }: { client: EClientKey }) => `/image/clients/logo/${client}.png`;

export const CLIENT_INTERVIEW_IMAGE_PATH = ({ client }: { client: EClientKey }) => `/image/clients/interview/${client}.png`;
